/* eslint-disable no-console */
/* eslint-disable import/no-cycle */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unicorn/consistent-function-scoping */
import { LoadingButton } from "@mui/lab";
import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography/Typography";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { HttpService } from "../../../constants/HTTPService";
import useModal from "../../../hooks/use-modal";
import { IJwtTokenData } from "../../../interfaces/IJwtTokenData";
import { publicRoutes } from "../../../routes/public";
import {
  setUserAvatar,
  setUserProfile,
  setUserRole,
} from "../../../store/auth/slice";
import { homeStyle } from "../../../styles/container/home";
import { setAuthToken, setLastVisitedPage } from "../../../utils/storage";
import Loading from "../../loading/loading";
import { getRoleNameProfileSA } from "./api-endpoint/callApi";

export function LoginContentByPass() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showModal } = useModal();

  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [emailLogin, setEmailLogin] = useState("");
  const [passwordLogin, setPasswordLogin] = useState("");

  const processAuthToken = async (token: string) => {
    setLoadingPage(true);

    // Decoding token
    const decodedToken: IJwtTokenData = jwtDecode(token);

    // Set Storage
    setAuthToken(token);

    // Get Role Profile
    const getRoleProfile = await getRoleNameProfileSA(decodedToken.BinusianId);

    // New Dispatch
    await Promise.all([
      dispatch(setUserProfile(decodedToken)),
      dispatch(setUserRole(getRoleProfile)),
      dispatch(setUserAvatar(undefined)),
    ]);

    // Finish Loading
    setLoadingPage(false);

    // Redirect to the appropriate page
    navigate("/", { replace: true });
    window.location.reload();
  };

  const handleByPass = async () => {
    setLoadingButton(true);
    setLoadingPage(true);

    const emailRegex = /^[^\s@]+@binus\.edu$/;

    if (!emailLogin || !passwordLogin) {
      showModal({
        title: "Input Required",
        message: "Email and password must be filled.",
        options: {
          variant: "failed",
        },
      });
      setLoadingButton(false);
      setLoadingPage(false);
      return;
    }

    if (!emailRegex.test(emailLogin)) {
      showModal({
        title: "Invalid Email",
        message: "Please enter a valid @binus.edu email address.",
        options: {
          variant: "failed",
        },
      });
      setLoadingButton(false);
      setLoadingPage(false);
      return;
    }

    const currentUrl = window.location.pathname;
    const excludedPaths = publicRoutes
      .map((route) => route.path)
      .filter((path): path is string => path !== undefined);

    if (!excludedPaths.includes(currentUrl)) {
      setLastVisitedPage(currentUrl);
    }

    try {
      // Get Token from API
      const authResponse = await HttpService.getAuthorizationTokenBypass(
        emailLogin,
        passwordLogin
      );

      const { tokenData } = authResponse.data;

      // Process the token
      await processAuthToken(tokenData.token);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoadingPage(false);

      const errorMessage =
        error instanceof Error
          ? error.message
          : "An error occurred during login, please try again.";

      showModal({
        title: "Login Failed",
        message: errorMessage,
        options: {
          variant: "failed",
        },
      });
    } finally {
      setLoadingButton(false);
    }
  };

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        Bypass Login
        <hr />
      </Box>
      <br />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: { xs: 4, md: 6 },
          alignItems: "stretch",
          minHeight: { md: 300 },
        }}
      >
        <Box sx={{ width: "100%", zIndex: 1, minHeight: { md: 300 } }}>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleByPass();
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              alignItems: "stretch",
              mb: 2,
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ mb: 1 }}>Email</Typography>
              <TextField
                placeholder="Isi email"
                type="email"
                fullWidth
                size="medium"
                sx={{ background: "#fff", borderRadius: 1 }}
                onChange={(e) => setEmailLogin(e.target.value)}
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography sx={{ mb: 1 }}>Password</Typography>
              <TextField
                placeholder="Isi password"
                type="password"
                fullWidth
                size="medium"
                sx={{ background: "#fff", borderRadius: 1 }}
                onChange={(e) => setPasswordLogin(e.target.value)}
              />
            </Box>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: { xs: "stretch", md: "flex-start" },
              }}
            >
              <LoadingButton
                variant="contained"
                onClick={handleByPass}
                type="submit"
                loading={loadingButton}
                disabled={loadingButton || loadingPage}
                loadingIndicator={
                  <CircularProgress sx={{ color: "#FFFFFF" }} size="20px" />
                }
                sx={{
                  background: "#7b3fa0",
                  borderRadius: 2,
                  px: 4,
                  fontWeight: 700,
                  letterSpacing: 1,
                  boxShadow: "none",
                  textTransform: "uppercase",
                  width: { xs: "100%", md: "auto" },
                  "&:hover": { background: "#5e2c7f" },
                }}
              >
                BYPASS
              </LoadingButton>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: { xs: "center", md: "center" },
            alignItems: { xs: "center", md: "flex-start" },
            minHeight: { xs: 120, md: 300 },
          }}
        >
          <Box
            component="img"
            src="/assets/image/alesa-login.png"
            alt="Alesa Illustration"
            sx={{
              width: { xs: "80%", md: 380 },
              maxWidth: "100%",
              height: "auto",
              borderRadius: 2,
              boxShadow: 0,
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>
      </Box>
      <Loading open={loadingPage} />
    </Container>
  );
}
